'use client'

import { useEffect } from 'react'

import HyperDX from '@hyperdx/browser'

function tracePropagationTargets(): (string | RegExp)[] {
  const raw = process.env.NEXT_PUBLIC_APP_URL
  if (!raw) {
    return [/cloudshuttle\.com\.au/i]
  }
  try {
    const host = new URL(raw).host
    return [new RegExp(host.replace(/\./g, '\\.'))]
  } catch {
    return [/cloudshuttle\.com\.au/i]
  }
}

/**
 * Browser RUM + session replay for ClickStack (HyperDX UI on ClickHouse Cloud).
 * Requires a public OTLP HTTP endpoint (collector) with CORS enabled for the site origin.
 * @see https://clickhouse.com/docs/use-cases/observability/clickstack/sdks/browser
 */
export function ClickStackBrowser() {
  useEffect(() => {
    const url = process.env.NEXT_PUBLIC_OTEL_EXPORTER_OTLP_ENDPOINT?.trim()
    if (!url) {
      return
    }

    HyperDX.init({
      url,
      apiKey: process.env.NEXT_PUBLIC_CLICKSTACK_INGESTION_API_KEY ?? '',
      service: process.env.NEXT_PUBLIC_OTEL_SERVICE_NAME ?? 'cloudshuttle-frontend',
      tracePropagationTargets: tracePropagationTargets(),
      consoleCapture: true,
    })
  }, [])

  return null
}
